import { RESOURCE } from '@src/constants';
import api from './api';

const getApps = async ({
  limit,
  offset,
  sort,
  search,
  searchFields,
  fields,
}) => {
  const response = await api({
    method: 'GET',
    url: RESOURCE.APPS,
    params: { limit, offset, sort, search, searchFields, fields },
  });
  return response;
};

const getApp = async (appId) => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.APPS}/${appId}`,
  });
  return response;
};

const createApp = async ({ name, expiresAt }) => {
  const response = await api({
    method: 'POST',
    url: RESOURCE.APPS,
    data: { name, expiresAt },
  });
  return response;
};

const statsRequestByApp = async ({ appId, startDate, endDate }) => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.STATISTICS}/apps/${appId}`,
    params: { startDate, endDate },
  });
  return response;
};

const getRequests = async ({
  limit,
  offset,
  sort,
  search,
  searchFields,
  fields,
  appId,
  startDate,
  endDate,
  status,
  signal,
}) => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.APPS}/${appId}/requests`,
    params: {
      limit,
      offset,
      sort,
      search,
      searchFields,
      fields,
      startDate,
      endDate,
      status,
    },
    signal,
  });
  return response;
};

const updateApp = async ({ appId, name, active }) => {
  const response = await api({
    method: 'PUT',
    url: `${RESOURCE.APPS}/${appId}`,
    data: { name, active },
  });
  return response;
};

export {
  getApps,
  getApp,
  createApp,
  statsRequestByApp,
  getRequests,
  updateApp,
};
